import { useState, useEffect } from 'react';
import { fieldValidator } from '../../utils/yupSchemaCreator';
import { ComboBox, FormControl } from '@airbus/components-react';

export default function FieldCreatableSelect(props) {
  const {
    rowId,
    initialValues,
    name,
    label,
    required,
    disabled,
    blurHandler,
    field,
    language,
    allDropdowns,
    setAllDropdowns,
  } = props;
  const options = allDropdowns[name] && allDropdowns[name]?.filter((item) => item.value);
  const [valueOptions, setValueOptions] = useState(options);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState(null);
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (initialValues) {
      let isTouched = false;
      if (
        initialValues?.isCommitRow ||
        (initialValues?.status === 'E' && initialValues?.backup?.[name] !== initialValues[name]) ||
        ((initialValues?.status === 'N' || initialValues?.status === 'C') &&
          initialValues?.touched[name])
      ) {
        isTouched = true;
      }
      setTouched(isTouched);
      if (isTouched) {
        const error = fieldValidator(field, initialValues[name], language);
        setError(error);
      }
      if (!initialValues[name]) {
        setSelected(null);
        return;
      }
      const valueObj = valueOptions?.find((item) => item.value == initialValues[name]);

      setSelected(valueObj);
    }
  }, [initialValues]);

  const handleChange = (obj) => {
    const { value = null } = obj;
    const valueObj = valueOptions.find((item) => item.value == value);
    const error = fieldValidator(field, value, language);
    if (value) {
      setSelected(valueObj);
    }
    setError(error);
  };

  const handleCreate = (value) => {
    const newOption = { label: value, value };
    setSelected(newOption);
    setAllDropdowns((prestate) => {
      const newstate = { ...prestate };
      newstate[name] = [...valueOptions, newOption];
      return newstate;
    });
    setValueOptions((options) => [...options, newOption]);
  };

  function handleBlur(e) {
    const value = e.target.defaultValue;
    const valueObj = valueOptions?.find((item) => item.value === value);
    setSelected(valueObj);
    blurHandler(name, valueObj?.value ?? null);
    if (field?.onValueChange) {
      const valid = field.onValueChange({ rowId, value: valueObj?.value, row: initialValues });
      if (valid === false) {
        if (!initialValues[name]) {
          setSelected(null);
          return;
        }
        const valueObj = valueOptions?.find((item) => item.value == initialValues[name]);
        setSelected(valueObj ?? null);
        return;
      }
    }
  }

  return (
    <FormControl
      {...{
        disabled,
        required,
        label,
      }}
      id={name}
      error={touched && Boolean(error)}
      errorText={touched && error?.msg}
    >
      <ComboBox
        {...{ name, disabled }}
        size='small'
        options={valueOptions}
        value={selected}
        creatable={true}
        onCreate={handleCreate}
        onChange={handleChange}
        onBlur={handleBlur}
        hideClear
      ></ComboBox>
    </FormControl>
  );
}
